module.exports = __webpack_public_path__ + "static/media/angle-up.8ebc0e48.svg";